export default __webpack_public_path__ + "static/media/about.e38c3e2c.svg";